import axios from "../utils/axios";

export const getBlogTags = async (params) => {
    try {
        const { data } = await axios.get('/blog-tags', { params });
        return data;
    } catch (error) {
        console.error("~ getBlogTags ~ error:", error);
        throw error;
    }
};

export const getBlogTagById = async (id) => {
    try {
        const { data } = await axios.get(`/blog-tags/${id}`);
        return data;
    } catch (error) {
        console.error("~ getBlogTagById ~ error:", error);
        throw error;
    }
};

export const createBlogTag = async (tagData) => {
    try {
        const { data } = await axios.post('/blog-tags', tagData);
        return data;
    } catch (error) {
        console.error("~ createBlogTag ~ error:", error);
        throw error;
    }
};

export const updateBlogTag = async (id, tagData) => {
    try {
        const { data } = await axios.put(`/blog-tags/${id}`, tagData);
        return data;
    } catch (error) {
        console.error("~ updateBlogTag ~ error:", error);
        throw error;
    }
};

export const deleteBlogTag = async (id) => {
    try {
        const { data } = await axios.delete(`/blog-tags/${id}`);
        return data;
    } catch (error) {
        console.error("~ deleteBlogTag ~ error:", error);
        throw error;
    }
};

export const forceDeleteBlogTag = async (id) => {
    try {
        const { data } = await axios.delete(`/blog-tags/${id}/force`);
        return data;
    } catch (error) {
        console.error("~ forceDeleteBlogTag ~ error:", error);
        throw error;
    }
};

export const restoreBlogTag = async (id) => {
    try {
        const { data } = await axios.post(`/blog-tags/${id}/restore`);
        return data;
    } catch (error) {
        console.error("~ restoreBlogTag ~ error:", error);
        throw error;
    }
};

export const massDestroyBlogTags = async (data) => {
    try {
        const response = await axios.delete('/blog-tags/mass-destroy', { data });
        return response.data;
    } catch (error) {
        console.error("~ massDestroyBlogTags ~ error:", error);
        throw error;
    }
};

export const massForceDeleteBlogTags = async (data) => {
    try {
        const response = await axios.delete('/blog-tags/mass-force-delete', { data });
        return response.data;
    } catch (error) {
        console.error("~ massForceDeleteBlogTags ~ error:", error);
        throw error;
    }
};

export const massRestoreBlogTags = async (data) => {
    try {
        const response = await axios.post('/blog-tags/mass-restore', data);
        return response.data;
    } catch (error) {
        console.error("~ massRestoreBlogTags ~ error:", error);
        throw error;
    }
};
